import { RefCallback, useCallback, useRef } from 'react';

const stopPropagation = (event: Event) => event.stopPropagation();

export function useClickStopPropagationRef<T extends HTMLElement>() {
    const ref = useRef<T | null>(null);

    const refCallback = useCallback<RefCallback<T>>((element) => {
        if (ref.current) {
            ref.current.removeEventListener('click', stopPropagation);
        }
        element?.addEventListener('click', stopPropagation);
        ref.current = element;
    }, []);

    return refCallback;
}
